export const baseLocation = [
  {
    code: "Within UAE",
    key: "Within UAE",
    value: "Within UAE",
    label: "Within UAE"
  },
  {
    code: "Outside UAE",
    key: "Outside UAE",
    value: "Outside UAE",
    label: "Outside UAE"
  }
];
